export const ACTION_GET_STATION_INFORMATION = '@stations/ACTION_GET_STATION_INFORMATION';
export const ACTION_SET_STATION_INFORMATION_SUCCESS = '@stations/ACTION_SET_STATION_INFORMATION_SUCCESS';
export const ACTION_SET_STATION_INFORMATION_FAILURE = '@stations/ACTION_SET_STATION_INFORMATION_FAILURE';
export const ACTION_GET_STATION_ACCESS_INSTRUCTIONS = '@stations/ACTION_GET_STATION_ACCESS_INSTRUCTIONS';
export const ACTION_SET_STATION_ACCESS_INSTRUCTIONS = '@stations/ACTION_SET_STATION_ACCESS_INSTRUCTIONS';
